export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-3-04.e95e98bc.jpg";